import React from "react";
import ApproveShippingAgencyTransfer from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/Approve/ApproveShippingAgencyTransfer";
import ClaimShippingAgencyTransfer from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/Claim/ClaimShippingAgencyTransfer";
import RejectShippingAgencyTransfer from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/Reject/RejectShippingAgencyTransfer";
import UnclaimShippingAgencyTransfer from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/Unclaim/UnclaimShippingAgencyTransfer";
import type { ShippingAgencyTransfer } from "@services/shipping-agency-transfer/types";

interface ShippingAgencyTransferFlowButtonsProps {
  openDrawer: (drawerName: string) => void;
  onApprove: () => void;
  transferDetails: ShippingAgencyTransfer | null;
}

const ShippingAgencyTransferFlowButtons: React.FC<ShippingAgencyTransferFlowButtonsProps> = ({
  transferDetails,
  openDrawer,
  onApprove,
}) => {
  return (
    <div className="flex gap-4 flex-wrap">
      <ClaimShippingAgencyTransfer transferDetails={transferDetails} />
      <UnclaimShippingAgencyTransfer transferDetails={transferDetails} />
      <RejectShippingAgencyTransfer transferDetails={transferDetails} openDrawer={openDrawer} />
      <ApproveShippingAgencyTransfer transferDetails={transferDetails} onApprove={onApprove} />
    </div>
  );
};

export default ShippingAgencyTransferFlowButtons;
